// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  ACMTooltip,
  AdditionalAntennaTooltip,
  FormatAntenna,
  FormatElevationHeader,
  FormatRadio,
  PassiveTooltip,
  PathSiteNames,
  ProjectPathInfo,
  ProjectPathInfoHeader,
  PathSummaryCell,
  SiteNameHeader,
} from 'components/PathSummary/components'

const columns = [{
  cellFormatter: ProjectPathInfo,
  cellTooltip: PassiveTooltip,
  columnKey: 'pathInfo',
  columnHeader: 'Path Info',
  columnWidth: '260px',
  headerFormatter: ProjectPathInfoHeader,
}, {
  cellFormatter: PathSiteNames,
  columnKey: 'siteName',
  columnHeader: 'Site Name',
  headerFormatter: SiteNameHeader,
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'callSign',
  columnHeader: 'Call Sign',
  columnWidth: '85px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'serviceContactCode',
  columnHeader: 'Contact',
  columnWidth: '85px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'latitude',
  columnHeader: 'Latitude',
  columnWidth: '120px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'longitude',
  columnHeader: 'Longitude',
  columnWidth: '120px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'groundElevation',
  columnHeader: 'G.E.',
  columnWidth: '70px',
  headerFormatter: FormatElevationHeader,
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'stateCode',
  columnHeader: 'State',
  columnWidth: '50px',
}, {
  cellFormatter: FormatAntenna,
  cellTooltip: AdditionalAntennaTooltip,
  columnKey: 'antennas',
  columnHeader: 'Antenna',
  columnWidth: '160px',
}, {
  cellFormatter: FormatRadio,
  cellTooltip: ACMTooltip,
  columnKey: 'radio',
  columnHeader: 'Radio',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'bandwidth',
  columnHeader: 'BW (MHz)',
  columnHeaderTitle: 'Channel Bandwidth',
  columnWidth: '100px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'numberOfFrequencies',
  columnHeader: '# CH',
  columnWidth: '50px',
}]

export default columns
